import { FunctionComponent } from 'react';
import { Box, Text } from '@rebass/emotion';

import { FormattedMessage } from 'react-intl';
import Dropdown from '../Dropdown';
import { QuantityLabel } from '../ProductLayout/styles';
import messages from '../ProductLayout/ProductLayout.messages';

const MAX_PRODUCTS_QUANTITY = 5;
const options = [...Array(MAX_PRODUCTS_QUANTITY).keys()].map((key) => ({
  key,
  value: key + 1,
}));

const QuantityDropdown: FunctionComponent<{
  value: number;
  onChange: (value: number) => void;
}> = ({ onChange, value }) => {
  return (
    <Box>
      <QuantityLabel>
        <Text fontSize={2} fontWeight={700} mb={[10]}>
          <FormattedMessage {...messages.quantity} />
        </Text>
        <Dropdown
          data-testid="quantity-dropdown"
          value={value}
          options={options}
          onChange={(value) => onChange(Number(value))}
        />
      </QuantityLabel>
    </Box>
  );
};

export default QuantityDropdown;
